import React from 'react'

const SupportAdmin = () => {
  return (
    <div>Support</div>
  )
}

export default SupportAdmin